<template>
    <div class="home-library">
        <div class="row m-0 pb-2 d-flex search-sort" id="search-sort">
            <div class="form-search col-5 pl-0 m-0">
                <div content="Tìm kiếm theo tên Thư viện" v-tippy class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fa-solid fa-magnifying-glass"></i></div>
                    </div>
                    <input v-model="search.library_name" type="text" class="form-control " id="inline-form-input-group"
                        placeholder="Tìm kiếm theo tên Thư viện">
                </div>
            </div>
            <div class="form-search col-3 pl-0 m-0">
                <select content="Loại thư viện" v-tippy class="form-control" v-model="big_search.category_name">
                    <option value="">Tất cả</option>
                    <option :value="category.category_name" v-for="(category, index) in library_categories" :key="index">{{
                        category.category_name }}</option>
                </select>
            </div>
            <div class="form-sort col-2 pl-0 m-0">
                <select content="Sắp xếp theo" v-tippy class="form-control " v-model="big_search.order_by">
                    <option value="id">Mới nhất</option>
                    <option value="library_price">Giá</option>
                    <option value="library_name">Tên</option>
                    <option value="category_name">Loại thư viện</option>
                </select>
            </div>
            <div class="form-sort col-2 pl-0 m-0 pr-0">
                <select content="Kiểu sắp xếp" v-tippy class="form-control " v-model="big_search.order_direction">
                    <option value="asc">Tăng dần</option>
                    <option value="desc">Giảm dần</option>
                </select>
            </div>
        </div>
        <div v-if="isLoading" class="d-flex justify-content-center container-loader">
            <flower-spinner class="loading-component" :animation-duration="2000" :size="30" color="#06C755" />
        </div>
        <ul v-if="!isLoading" class="ul-library">
            <li class="library-item" v-for="(record, index) in records" :key="index" @click="gotoRecordDetail(record)">
                <img class="img-cover-library"
                    :src="record.library_image ? record.library_image : require('@/assets/home/item-source.jpg')"
                    alt="Course Thumbnail">
                <div class="content">
                    <h2 class="h2-name-library">{{ this.$truncatedTitle(record.library_name, 100) }}</h2>
                    <h1 class="h1-price"> <span><i class="fa-solid fa-dong-sign"></i></span> {{ this.$formatNumber(record.library_price) }}</h1>
                </div>
            </li>
        </ul>
        <div v-if="!isLoading" id="divpaginate" class="mt-2">
            <paginate v-if="paginateVisible" :page-count="last_page" :page-range="3" :margin-pages="1"
                :click-handler="clickCallback" :initial-page="big_search.page" :prev-text="'Prev'" :next-text="'Next'"
                :container-class="'pagination'" :page-class="'page-item'">
            </paginate>
        </div>
    </div>
</template>
<script>
import UserRequest from '@/restful/UserRequest';
import Paginate from 'vuejs-paginate-next';
import { FlowerSpinner } from 'epic-spinners';
import _ from 'lodash';
export default {
    name: "HomeLibrary",
    components: {
        FlowerSpinner,
        paginate: Paginate,
    },
    data() {
        return {
            isLoading: false,
            total: 0,
            last_page: 1,
            paginateVisible: true,
            search: {
                library_name: '',
            },
            big_search: {
                per_page: 10, // const
                page: 1,
                order_by: 'id',
                order_direction: 'desc',
                category_name: '',
            },
            query: '',
            records: null,
            library_categories: [],
        }
    },
    mounted() {
        this.$setDocumentTitle('Danh sách Thư viện');
        this.$emitEvent('NameRouting', 'Thư viện');

        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        this.search.library_name = searchParams.get('library_name') || '';
        this.big_search = {
            per_page: parseInt(searchParams.get('per_page')) || 10,
            page: searchParams.get('page') || 1,
            order_by: searchParams.get('order_by') || 'id',
            order_direction: searchParams.get('order_direction') || 'desc',
            category_name: searchParams.get('category_name') || '',
        }

        this.getListLibraryCategory();
        this.getDataRecords();
    },
    beforeUnmount() {
        this.$emitEvent('NameRouting', '');
    },
    methods: {
        gotoRecordDetail: function (record) {
            this.$router.push({ name: 'HomeLibraryDetail', params: { slug_name_library: record.library_slug + '-id-record-' + record.id } });
        },
        getDataRecords: async function () {
            this.isLoading = true;
            this.query = `?library_name=${this.search.library_name}&order_by=${this.big_search.order_by}&order_direction=${this.big_search.order_direction}&page=${this.big_search.page}&per_page=${this.big_search.per_page}&category_name=${this.big_search.category_name}`;
            // window.history.pushState({}, null, this.query);
            window.history.replaceState({}, null, this.query);
            try {
                const { data } = await UserRequest.get('user/library/get-all' + this.query)
                this.records = data.data;
                this.total = data.total;
                this.last_page = data.last_page;
                this.isLoading = false;
            }
            catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
                this.isLoading = false;
            }
            this.reRenderPaginate();
        },
        reRenderPaginate: function () {
            if (this.big_search.page > this.last_page) this.big_search.page = this.last_page;
            this.paginateVisible = false;
            this.$nextTick(() => { this.paginateVisible = true; });
        },
        clickCallback: function (pageNum) {
            this.big_search.page = pageNum;
        },
        getListLibraryCategory: async function () {
            try {
                const { data } = await UserRequest.get('home/category-library/get-data')
                this.library_categories = data;
            }
            catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }
        }
    },
    watch: {
        big_search: {
            handler: function () {
                this.getDataRecords();
            },
            deep: true
        },
        search: {
            handler: _.debounce(function () {
                this.getDataRecords();
            }, 500),
            deep: true,
        },
    }
}
</script>
<style scoped src="./homelibrary-responsive.css"></style>
<style scoped>
/* loading */
.container-loader {
    height: 300px;
    align-items: center;
    align-content: center;
    display: flex !important;
    justify-content: center;
}

.container-loader .loading-component {
    margin: 0 !important;
}

/* loading */
</style>